import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BASE_URL } from "../../helpers/constants";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useApiRequest from "../../helpers/api_request";
import { Link, useNavigate, useParams } from "react-router-dom";
import { selectAccessToken } from "../../features/auth/authSlice";
import AppButton from "../elements/AppButton";
import useAdminsRequest, { TypeUser } from "../../hooks/useAdminsRequest";
import PasswordInput from "../elements/PasswordInput";
import useRolesRequest from "./useRolesRequest";
import useErrorToast from "../../helpers/errorToast";

const CreateAdminPage = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const apiRequest = useApiRequest()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const accessToken = useAppSelector(selectAccessToken);
    const [isSaving, setIsSaving] = useState(false)
    const [password, setPassWord] = useState("");
    const { id } = useParams();
    const errorToast = useErrorToast()
    const { loadingUsers, users, getUsers } = useAdminsRequest();
    const { fetchingRoles, roles, getRoles } = useRolesRequest()
    useEffect(() => {
        getRoles()
    }, [])

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        if (id != null) {
            const user = users.filter((item) => item.id == id)
            if (user.length > 0) {
                setFirstName(user[0].first_name)
                setLastName(user[0].last_name)
                setEmail(user[0].email)
            }
        }
    }, [users])

    const assignRole = async (user:TypeUser)=>{
        try {
            const response = await apiRequest({
                method: "post",
                url: BASE_URL + "/api/user-role/assign",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                data: {
                    user_id: user.id,
                    role_id: role,
                }
            });
            setIsSaving(false)
            dispatch(
                showToastMessage({
                    message: "User Saved",
                    type: "success",
                    position: toast.POSITION.TOP_RIGHT
                })
            );
            navigate("/admins");
        } catch (error: any) {
            setIsSaving(false)
            errorToast(error);

        }
    }

    const saveRecord = async () => {
        if (firstName === "" || email === "") {
            dispatch(
                showToastMessage({
                    message: "name and email are required",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                })
            );
            return;
        }

        try {
            setIsSaving(true)
            const response = await apiRequest({
                method: "post",
                url: BASE_URL + "/api/create-user",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                data: {
                    first_name: firstName,
                    last_name: lastName,
                    email: email,
                    password:password
                }
            });
           await assignRole(response.data)
        } catch (error: any) {
            setIsSaving(false)
            errorToast(error);
        }
    };

    return (
        <div>
            <div className="card">
                <div className="card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between" aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <Link to={"/admins"}>
                                    <div className="flex items-center">
                                        <h5 className="card-title">Admins</h5>
                                    </div>
                                </Link>
                                <span className="mx-2 text-gray-400">/</span>
                                <li aria-current="page">
                                    <div className="flex items-center">
                                        <h5 className="card-title">Create</h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="h-fit flex-grow flex flex-col justify-center">
                        <div className="w-2/3 mt-4 flex gap-2">
                            <div className="w-1/2">
                                <label className="block text-sm font-medium text-gray-700">
                                    First name
                                </label>
                                <input
                                    type="text"
                                    id="firstName"
                                    className="form-input-2"
                                    placeholder=""
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="w-1/2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Last name
                                </label>
                                <input
                                    type="text"
                                    id="lastName"
                                    className="form-input-2"
                                    placeholder=""
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <input
                                type="text"
                                id="email"
                                className="form-input-2"
                                placeholder=""
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700">
                                Role
                            </label>
                            <select value={role} onChange={(e) => setRole(e.target.value)} name="" className="form-input-2" id="">
                                <option value="">Select</option>
                                {
                                    roles.map((item, key) => <option value={item.id} key={key}>{item.name}</option>)
                                }
                            </select>
                        </div>

                        <div className="w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700">
                                Password
                            </label>
                            <PasswordInput className="form-input-2 pl-10" getPasswordValue={(password) => setPassWord(password)} />


                        </div>

                        <div className="w-2/3 mt-4">
                            <AppButton callBackFun={() => saveRecord()} showLoader={isSaving} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2" text="Save" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateAdminPage;
